import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Treatments.css";
import logo from '../images/6_Ayur copy.webp'
import serviceImg from "../images/main_life.webp";
import { MdOutlineMail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import AyurvedaFooter from "../AyurvedaFooter/AyurvedaFooter";
import ScrollToTop from '../ScrollToTop'
import { MdCall } from "react-icons/md";
import { NavLink, useLocation } from "react-router-dom";
import WhatsAppButton from "../WhatsAppButton";
import { FaLocationArrow } from "react-icons/fa6";
import ScrollTop from "../ScrollTop";
import { Helmet } from 'react-helmet-async';

export default function LifeCycle() {
  const location = useLocation();

  const isTreatmentActive =
    location.pathname.startsWith("/treatment") ||
    location.pathname.startsWith("/postnatal") ||
    location.pathname.startsWith("/rejuvenation") ||
    location.pathname.startsWith("/hair_treatment") ||
    location.pathname.startsWith("/lifestyle_yoga") ||
    location.pathname.startsWith("/soundarya_kalpa");
  return (
    <>
    <Helmet>
  <title>
    Lifestyle Guidance & Yoga in Kerala
  </title>

  <meta
    name="description"
    content="Discover holistic Lifestyle Guidance and Yoga at Ayurmoksha Ayurveda clinic in Kozhikode, Kerala. Our personalized Ayurvedic lifestyle consultations and traditional yoga sessions help reduce stress, improve flexibility, enhance mental clarity, and promote long-term physical and emotional well-being."
  />

  <meta
    name="keywords"
    content="Lifestyle Guidance Ayurveda Kozhikode, Ayurvedic Lifestyle Consultation Kerala, Yoga Therapy Kozhikode, Traditional Yoga Kerala, Stress Management Ayurveda Kerala, Ayurmoksha Lifestyle Guidance, Yoga and Ayurveda Kozhikode"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://ayurmoksha.in/lifestyle_yoga" />

  {/* Open Graph Meta */}
  <meta property="og:locale" content="en_IN" />
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Lifestyle Guidance & Yoga | Ayurmoksha Ayurveda clinic Kozhikode"
  />
  <meta
    property="og:description"
    content="Ayurmoksha Ayurveda clinic in Kozhikode offers personalized Ayurvedic lifestyle guidance and yoga therapy to improve daily routines, mental balance, physical health, and overall wellness."
  />
  <meta
    property="og:url"
    content="https://ayurmoksha.in/lifestyle_yoga"
  />
  <meta
    property="og:site_name"
    content="Ayurmoksha Ayurveda clinic"
  />
  <meta
    property="og:image"
    content="https://ayurmoksha.in/logo.webp"
  />
  <meta
    property="og:image:alt"
    content="Lifestyle Guidance and Yoga Therapy at Ayurmoksha Ayurveda clinic in Kozhikode Kerala"
  />

  <meta name="author" content="Ayurmoksha Ayurveda clinic" />
</Helmet>

    <ScrollTop/>
      {/* main section */}
      <section className="container-fluid about-main-section">
      {/* Overlay */}
      <div className="about-main-overlay"></div>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark about-navbar">
        <div className="container">

          {/* Logo */}
           <a className="navbar-brand" href="#"><span><img src={logo} alt="logo" className="brand-logo bg_new"/><span  className=" logo_txt mt-5" ></span></span>
          </a>

          {/* Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#aboutNavbar"
            aria-controls="aboutNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          <div className="collapse navbar-collapse justify-content-center" id="aboutNavbar">

              <ul className="navbar-nav align-items-lg-center gap-lg-3 text-center">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Home</b></NavLink>
              </li>

              <li className="nav-item">
              
                <NavLink  className="nav_Active" to="/ourstory" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Our Story</b></NavLink>
              </li>

             <li className="nav-item dropdown">
  <NavLink
    to="/treatment"
    className="nav-link dropdown-toggle"
    data-bs-toggle="dropdown"
    style={() => ({
      color: isTreatmentActive ? "orange" : "white"
    })}
  >
    <b>Treatments</b>
  </NavLink>

  <ul className="dropdown-menu">
    <li>
      <NavLink
        to="/treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        All Treatments
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/postnatal"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Postnatal Care
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/rejuvenation"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Rejuvenation Therapy
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/hair_treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Hair Treatment
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/lifestyle_yoga"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Life Style Guidance & Yoga
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/soundarya_kalpa"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Soundarya Kalpa
      </NavLink>
    </li>
  </ul>
</li>

                <li className="nav-item">
                  <NavLink className="nav_Active" to="/contact" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>contact</b></NavLink>
              </li>
             
            </ul>
          </div>

        </div>
        <div className="d-none d-lg-flex align-items-center gap-3 ms-auto">
<span className="phone-inline">
  <MdCall/> <b>+91 7736 111 482</b>
</span>


  <a
    href="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20know%20more%20about%20your%20treatments"
    target="_blank"
    rel="noopener noreferrer"
    className="messenger-btn"
    style={{ backgroundColor: "#006400", textDecoration: "none" }}
  >
    WhatsApp
  </a>
</div>

      </nav>

      {/* Center Content */}
      <div className="about-main-content">
        <h1 className="head-font" style={{color:'#f7f0d3'}}> Life Style Guidance & Yoga</h1>
        <p>
          <span className="para-font">Home</span>
          <span className="mx-2">»</span>
          <span className="para-font"> Life Style Guidance & Yoga</span>
        </p>
      </div>
    </section>
    {/* =========== */}
    <section className="service-detail-wrapper">
      <div className="container">
        <div className="row">

          {/* LEFT CONTENT */}
          <div className="col-lg-8 mb-5 mb-lg-0">
            <div className="service-image">
              <img src={serviceImg} alt="Abhyanga Therapy" style={{height:'500px'}} />
            </div>

            <h2 className="service-title">Life Style Guidance & Yoga</h2>

            <p className="service-desc para-font justify-text ">
              Designed to support holistic well-being, this program aligns daily habits with time tested Ayurvedic principles. Personalized lifestyle recommendations help establish healthy routines that support digestion, sleep, and overall vitality. Complemented by guided yoga sessions, the program improves flexibility, reduces stress, enhances energy levels, and promotes mental clarity. Together, these practices restore balance to the body and mind, encouraging long-term wellness and mindful living.
            </p>

            <h5 className="service-subtitle">How beneficial is Lifestyle Guidance & Yoga program  </h5>

            <div className="row service-benefits">
              <div className="col-md-6">
                <ul className="para-font">
                  <li>✔ Aligns daily habits with Ayurvedic principles</li>
                  <li>✔ Establishes healthy routines for digestion and sleep</li>
                  <li>✔ Reduces stress, anxiety, and mental fatigue</li>
                   <li>✔ Improves flexibility, strength, and posture</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="para-font">
                  <li>✔ Enhances energy levels and stamina</li>
                  <li>✔ Supports immunity and overall vitality</li>
                  <li>✔ Encourages mindful living and self-awareness</li>
                  <li>✔ Helps prevent lifestyle-related health imbalances</li>
                </ul>
              </div>
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="col-lg-4">
            <div className="service-sidebar">

              <div className="sidebar-card">
                 <h5 style={{color:'wheat'}}>Our Services</h5>
                <ul className="para-font">
                  <li><FaLocationArrow />&nbsp;&nbsp;Postnatal Care</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Rejuvenation Therapy</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Hair Treatments</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Life Style Guidance & Yoga</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Soundarya Kapla</li>
                </ul>
              </div>

              <div className="sidebar-card">
                <h5 style={{color:'wheat'}}>How it works</h5>
                <ul className="para-font">
                  <li><FaLocationArrow />&nbsp;&nbsp;Personalized Lifestyle Assessment</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Ayurvedic Lifestyle Guidance</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Diet & Habit Recommendations</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Guided Yoga Sessions</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Stress Management & Relaxation</li>
                  <li><FaLocationArrow />&nbsp;&nbsp;Metabolic Wellness Guidance</li>
                </ul>
              </div>

              <div className="sidebar-card">
                <h5 style={{color:'wheat'}}>Our Contact</h5>
                 <ul className="para-font">
                     <li><FaPhone/> +91 7736 111 482</li>
                    <li><MdOutlineMail/> ayurmokshacalicut@gmail.com</li>
                    <li><FaLocationDot/>&nbsp;Ruby Road, Karuvanthuruthy, Feroke, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Kozhikode,Kerala 673631</li>
                   </ul>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
    <AyurvedaFooter/>
    <ScrollToTop/>
     <WhatsAppButton/>
    </>
  );
}
